import { AsnStatus } from '@invenco/supply-interface';

import type { AsnsQueryQuery } from '@/graphql/generated/seller/graphql';
import { convertDateTimeToISO, getEnumValue } from '@/shared/helpers';
import { ListData } from '@/shared/types';

export type AsnListItem = {
  id: string;
  name: string;
  createdAt: string;
  status?: AsnStatus;
  reference?: string;
  expectedAt?: string;
  locationName?: string;
  qtyExpected?: number;
  qtyReceived?: number;
  closedAt?: string;
};

export class AsnListMapper {
  private static getClosedAt(rawValue: string) {
    const isoClosedAt = convertDateTimeToISO(rawValue);
    return isoClosedAt === '1970-01-01T00:00:00.000Z' ? undefined : isoClosedAt;
  }

  static toData(response: AsnsQueryQuery): ListData<AsnListItem> {
    const total = response?.asnsAggregate?._count ?? 0;
    const data = Array.isArray(response.asns)
      ? response.asns.map((asn) => ({
          id: asn.id,
          name: asn.name,
          createdAt: convertDateTimeToISO(asn.createdAt),
          status: asn.status ? getEnumValue(AsnStatus, asn.status) : undefined,
          reference: asn.reference || undefined,
          expectedAt: asn.expectedAt ? convertDateTimeToISO(asn.expectedAt) : undefined,
          locationName: asn.locationName || undefined,
          qtyExpected: asn.qtyExpected ?? undefined,
          qtyReceived: asn.qtyReceived ?? undefined,
          closedAt: AsnListMapper.getClosedAt(asn.closedAt),
        }))
      : [];

    return {
      data,
      total,
    };
  }
}
